import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PageActions } from "../../store/ducks/pages";
import { Creators as ConsignadoInssActions } from "../../store/ducks/consignadoInss";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import CloseIcon from "@material-ui/icons/Cancel";

const tenant = localStorage.getItem("@ecorban-app:tenant");

class MainAppBar extends Component {
  state = {
    redirect: false
  };
  handleChange = (event, value) => {
    // console.log(value);
  };

  handleClose = (name, e) => {
    e.preventDefault();
    let pages = this.props.pages.openedPages.filter(page => {
      return page.name !== name;
    });
    if (pages.length > 0) {
      const tenant = localStorage.getItem("@ecorban-app:tenant");
      if (this.props.pages.currentPageName === name) {
        let index = 0;
        let pivot = this.props.pages.openedPages;
        pivot.forEach((page, i) => {
          if (page.name === name) {
            index = i > 0 ? i - 1 : i + 1;
          }
        });
        this.props.setPage(
          this.props.pages.openedPages[index].name,
          this.props.pages.openedPages[index].path.replace(`/${tenant}/`, "")
        );
        this.setState({ redirect: true });
      }
      this.props.closePage(pages);
    }
  };

  componentDidUpdate() {
    if (this.state.redirect) {
      this.props.history.push(`/${tenant}/${this.props.pages.currentPagePath}`);
      this.setState({ redirect: false });
    }
  }

  render() {
    return (
      <div
        style={{
          position: "relative"
        }}
      >
        <AppBar
          position="static"
          color="default"
          className="app-bar"
          id="topo-app-bar"
        >
          {this.props.totalPages > 0 && (
            <Tabs
              value={this.props.pages.currentPageName}
              onChange={this.handleChange}
              scrollable
              scrollButtons="auto"
              classes={{ indicator: "tabsIndicator" }}
            >
              {this.props.pages.openedPages.map(page => (
                <Tab
                  value={page.name}
                  key={page.name}
                  label={page.name}
                  component={NavLink}
                  to={page.path}
                  icon={
                    <CloseIcon onClick={e => this.handleClose(page.name, e)} />
                  }
                />
              ))}
            </Tabs>
          )}
        </AppBar>
        {this.props.loadingUpload && (
          <div
            style={{
              position: "absolute",
              right: "40px",
              fontSize: "3rem",
              top: "50%",
              zIndex: "9999",
              marginTop: "-20px",
              color: "rgba(0,0,0, .65)"
            }}
          >
            <i className="fa fa-spinner fa-pulse" />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pages: state.pages,
  totalPages: state.pages.currentPagePath.length,
  consignadoInss: state.consignadoInss,
  loadingUpload: state.loadingUpload.loadingUpload
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...PageActions, ...ConsignadoInssActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MainAppBar)
);



// WEBPACK FOOTER //
// ./src/components/MainAppBar/index.js